export default {
  default: {
    add: 'Add',
    editTags: 'Edit Tags',
    finishEditing: 'Finish Editing',
    tag: 'Tag',
  },
}
